import { FaMapMarkerAlt, FaClock, FaMedal } from "react-icons/fa";
import { FaShieldDog } from "react-icons/fa6";


const eventHero = {

    lsl_joya: {

        titulo: "LSL MTB EL SEÑOR DE LA JOYA 2026",

        descripcion:
            "Prepárate para desafiar la montaña, la arena y tus propios límites en El Señor de La Joya. Vive la adrenalina de la SUPER LIGA MOUNTAIN BIKE, una experiencia única que te llevará a la gloria sobre dos ruedas.",

        video:
            "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/LSL%20MTB%20JOYA%202026/Se%C3%B1or%20de%20la%20joya%20CICLISMO.mp4?updatedAt=1789667290649",

        logo:
            "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/logo-largo-blanco.png",

        detalles: [

            {
                id: 1,
                icon: <FaMapMarkerAlt />,
                label: "Lugar",
                value: "La Joya, Arequipa, Perú"
            },

            {
                id: 2,
                icon: <FaClock />,
                label: "Hora",
                value: "08:00 AM"
            },

            {
                id: 3,
                icon: <FaMedal />,
                label: "Premios",
                value: "Reconocimientos a ganadores"
            }

        ]

    },

    aqp_trail_chilina: {

        titulo: "AQP TRAIL RUNNING SERIES INTERNATIONAL 2026 - EL VALLE DE CHILINA",

        descripcion:
            "Prepárate para desafiar la altura, los senderos ancestrales y tus propios límites en “El Valle de Chilina”. Cada kilómetro pondrá a prueba tu resistencia y determinación. Vive la adrenalina de una experiencia única rumbo a la gloria de la AQP TRAIL RUNNING SERIES INTERNATIONAL 2026.",

        video:
            "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/AQP_TRS_CHILINA_2026/El%20Valle%20de%20Chilina%20Trail.mp4",

        logo:
            "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/logo-blanco.png?updatedAt=1789420774705",

        detalles: [

            {
                id: 1,
                icon: <FaMapMarkerAlt />,
                label: "Lugar",
                value: "Chilina, Arequipa, Perú"
            },

            {
                id: 2,
                icon: <FaClock />,
                label: "Hora",
                value: "08:00 AM"
            },

            {
                id: 3,
                icon: <FaMedal />,
                label: "Premios",
                value: "Reconocimientos a ganadores"
            }

        ]

    },

    corro_ninos_2026: {

        titulo: "YO CORRO POR LOS NIÑOS 6K 2026",

        descripcion:
            "Corre por una causa noble y sé parte del cambio. Únete a nosotros en la carrera Yo Corro por los Niños 6K, un evento a beneficio del albergue de perritos Ayúdanos a Ayudar. Cada paso que das se convierte en alimento, refugio y cuidado para los peluditos que más lo necesitan. ¡Juntos podemos marcar la diferencia y dejar una huella imborrable en sus vidas!",

        video:
            "https://res.cloudinary.com/zmudqget/video/upload/v1790271090/ASD.mp4",

        logo:
            "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/logo-largo-blanco.png?updatedAt=1789420473135",

        detalles: [

            {
                id: 1,
                icon: <FaMapMarkerAlt />,
                label: "Lugar",
                value: "Characato, Arequipa, Perú"
            },

            {
                id: 2,
                icon: <FaClock />,
                label: "Hora",
                value: "08:00 AM"
            },

            {
                id: 3,
                icon: <FaShieldDog />,
                label: "BENÉFICO",
                value: "Apoya a mascotas necesitadas"
            }

        ]

    },

};

export default eventHero;